const isEmail = (email) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

const newsLetterSignupSuccess = (data) => {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      gaCategory: "Formulieren",
      gaAction: "Nieuwsbriefinschrijving",
      event: "gaEvent"
    });
  }

  if (data.email !== undefined) {
    document.body.classList.add("newsletter-subscribe-success");
  } else {
    document.querySelector(".newsletter-already-signed-up-js").classList.remove("hidden");
  }
};

if (document.querySelector(".newsletter-button-js")) {
  document.querySelector(".newsletter-button-js").addEventListener("click", (e) => {
    e.preventDefault();
    const newsletterInput = document.querySelector(".newsletter-input-js");
    console.log(reservationsApi);
    if (isEmail(newsletterInput.value)) {
      document.querySelector(".newsletter-signup-error-js").classList.add("hidden");
      reservationsApi.signUpNewsletter(newsletterInput.value, newsLetterSignupSuccess);
    } else {
      document.querySelector(".newsletter-signup-error-js").classList.remove("hidden");
    }
    console.log(newsletterInput.value);
  });
}
